const githDescription = require('./gith')
const githzeraiDescriptionPure = require('./githzeraiPure')

module.exports = [
  ...githDescription,
  ...githzeraiDescriptionPure,
]
